/*
 * @Descripttion: 
 * @version: 
 * @Author: Xiemenjie
 * @Date: 2020-12-07 09:57:12
 * @LastEditors: TangXihao
 * @LastEditTime: 2021-08-27 11:15:35
 */
import React from 'react';
import { connect } from 'react-redux'
import { HashRouter, Route, Redirect } from 'react-router-dom'
// import NewsHeader from './NewsHeader'
// import NewsPages from './NewsPages'

// import Search from './Components/Search'
// import NewsDetail from './Components/NewsDetail/NewsDetail'
import Notice from './Components/NoticesDetail/NoticesDetail'
import './index.css'
import { Layout, ConfigProvider } from 'antd';
import zhCN from 'antd/es/locale/zh_CN'; // 中文语言包；
// import Header2 from '../../Header/Header2';
import HomeHearder from 'src/components/Pages/Home/NewHome/HomeHearder'
import Header4 from '../../Header/Header4';
import News from './Components/News/News';
import NewsDetail from './Components/NewsDetail/NewsDetail';

/**
 * 新闻公告展示主页面
 */
class NewsManager extends React.Component {


    render() {

        return (
            // <div className='NewsBulletin'>
                <ConfigProvider locale={zhCN}>
                    <div className='Home_IntroduceTitle'>
                        {this.props.loginObj && this.props.loginObj.login && this.props.loginObj.token !== undefined
                            ?
                            <Header4 />
                            :
                            <HomeHearder />
                        }
                    </div>
                    <div className='layoutNews'>
                        {/* <div className='contents-box-size'> */}

                        {/* <HashRouter> */}
                        <Route path='/NewsBulletin' exact component={News} />
                        <Route path='/NewsBulletin/Newsdetail/:id' exact component={NewsDetail} />
                        <Route path='/NewsBulletin/Notice/:id' exact component={Notice} />
                        {/* </HashRouter> */}
                        {/* </div> */}
                    </div>

                </ConfigProvider>
            // </div>
        );
    }
}

const mapState = (state) => ({
    loginObj: state.userReducer.get('loginObj').toJS(),
    user: state.userReducer.get('user').toJS()
})
const mapDispatch = (dispatch) => ({
})
export default connect(mapState, mapDispatch)(NewsManager);


